<template>
  <!-- 一括状態変更 -->
  <div id="DeviceStatusBulkChange">
    <div id="container">
      <deviceNavi v-bind:pageid='"DeviceManagement"'></deviceNavi>
      <div class="labelTitle lable">一括状態変更</div>
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>シリアル番号</th>
            <td><input type="text" v-model="serial" @keyup.enter="onKeyupEnter()"/></td>
          </tr>
        </table>
        <b-button class="addButton is-primary" @click="addDevice">追加</b-button>
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
      <div class="result-area">
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>状態</th>
              <td>
                <select id="status" v-model="status" :disabled="!data.length">
                  <option v-for="machineStatus of machineStatusList" :value="machineStatus.value" :key="'s' + machineStatus.value">
                    {{machineStatus.label1}}
                  </option>
                </select>                
              </td>
            </tr>
          </table>
          <b-button class="addButton is-primary" :disabled="!data.length" @click="statusChange">状態変更</b-button>
        </div>
        <b-table
            style="margin-top:10px;"
            v-if="data.length"
            id="deviceStatusBulkChangeTable"
            :data="data">
            <template slot-scope="props">
              <b-table-column field="" label="#" width="50" centered>{{props.index +1}}</b-table-column>
              <b-table-column field="serial" label="シリアル" width="120" sortable centered>
                {{props.row.serial}}
              </b-table-column>
              <b-table-column field="kind" label="種別" width="170" sortable >
                {{props.row.inspectionKind }}
              </b-table-column>
              <b-table-column field="itemCode" label="品目コード" width="80" sortable centered>
                {{props.row.itemCode }}
              </b-table-column>
              <b-table-column field="itemName" label="品目名称" sortable >
                {{props.row.itemName}}
              </b-table-column>
              <b-table-column field="status" label="状態" width="110" centered sortable >
                  <span :class="getMachineStatusTagClass(props.row.statusCode)">
                    {{props.row.status}}
                  </span>
              </b-table-column>
              <b-table-column field="returnDate" label="返却日" width="80" centered sortable >
                <template v-if="props.row.statusCode == machineStatus.deviceReady || props.row.statusCode == machineStatus.shipping || props.row.statusCode == machineStatus.overdue">
                  {{replaceSlash(props.row.scheduledReturnDate)}}
                </template>
              </b-table-column>
              <b-table-column field="storage" label="保管場所" width="200" sortable >
                {{props.row.storageLocation}}
              </b-table-column>
              <b-table-column field="warehousingDate" label="入庫日" width="80" centered sortable >
                {{replaceSlash(props.row.warehousingDate)}}
              </b-table-column>
              <b-table-column field="leaseStartDate" label="リース開始日" width="90" centered sortable >
                {{replaceSlash(props.row.leaseStartDate)}}
              </b-table-column>
              <b-table-column field="leaseEndDate" label="リース終了日" width="90" centered sortable >
                {{replaceSlash(props.row.leaseEndDate)}}
              </b-table-column>
              <b-table-column field="leaseUpDate" label="リースアップ日" width="110" centered sortable >
                {{replaceSlash(props.row.leaseUpDate)}}
              </b-table-column>
              <b-table-column field="delete" label="削除" width="50" centered >
                <b-button class="clearButton" @click="clearDevice(props.index)" icon-left="eraser"></b-button>
              </b-table-column>
            </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import {choicesType} from "@/components/mock/base/const.js";
import {machineStatus} from "@/components/mock/base/const.js";
import naviBar from "@/components/mock/philips/device/DeviceNaviBar";

export default {
  name: "DeviceStatusBulkChange",
  methods: {
    onKeyupEnter: function() {
      if (this.serial) {
        let serialItems = this.serial.split('/');
        if(serialItems.length == 2){
          //　"/"が含まれていたらそれ以降の文字に変更する
          this.serial = serialItems[1]
        }
        this.addDevice()
      }
      else {
        this.addDevice()
      }
    },
    addDevice: function(){
      if(!this.serial){
        var messsge ="シリアル番号を入力してください。";
        this.$dialog.alert({
          title: '　',
          message: messsge,
        })
      } else if (this.exists(this.serial)) {
        var messsge ="指定したシリアル番号は既に追加されています。";
        this.$dialog.alert({
          title: '　',
          message: messsge,
        })
      } else {
        var _this = this;
        this.apiCall(
          function(client){
            return client.apis.internalDeviceManagement.getDeviceListPOST({
              body:{
                exactMatch: true,
                serial: _this.serial,
                inspectionKind: "",
                itemCode: "",
                status: "",
              }
            });
          },
          function(result){
            if (result.obj.length) {
              _this.data.push(result.obj[0]);
              _this.serial = "";
            } else {
              _this.showErrorMessage('指定されたシリアル番号は登録されていません。');
            }
          },
          function(result){
            _this.showErrorMessage(result);
          }
        );
      }
    },
    exists: function(serial) {
      var item = this.data.find(item => {
        return item.serial == serial
      })

      return item ? true : false
    },
    clearDevice: function(index) {
      this.data.splice(index, 1);
    },
    statusChange: function(){
      var _this = this;

      var selectStatus = this.machineStatusList.find(status => {
        return status.value == _this.status
      })
      var messsage ="状態を「" + selectStatus.label1 + "」に変更します。";
      this.$dialog.confirm({
        title: "確認",
        message: messsage,
        cancelText: "キャンセル",
        onConfirm: () => {
          
          var serials = []
          this.data.forEach(row => {
            serials.push(row.serial)
          })
          this.apiCall(
            function(client){
              return client.apis.internalDeviceManagement.setDeviceStateChangePOST({
                body:{
                  serial: serials,
                  status: _this.status
                }
              });
            },
            function(result){
              _this.showSuccess(result, function(){
                for(var item of _this.data){
                  item.status = selectStatus.label1
                  item.statusCode = selectStatus.value
                }
              });
            },
            function(result){
              _this.showErrorMessage(result);
            }
          );
        }
      });
    },
    back: function() {
      this.$router.go(-1);
    }
  },
  data() {
    let machineStatusList = this.getChoiceList(choicesType.machineStatus, true)

    return {
      data : [],
      serial:null,
      status:"1",
      machineStatusList: machineStatusList,
      machineStatus: machineStatus,
    };
  },
  filters: {},
  components: {
    deviceNavi: naviBar,
  },
};
</script>
<style lang="scss" scoped>
.condition-area {
    display: flex;
}
.conditionTable {
  width: 400px;
}
.addButton {
    margin-left:20px;
}
.backButton {
  margin-left: auto;
}
.result-area {
  margin-top: 20px;
}
a {
  text-decoration: underline;
}
.opration-area {
    height:50px;
    margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/device/DeviceStatusBulkChange.vue